"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _moment = _interopRequireDefault(require("moment"));

var CONSTANTS = _interopRequireWildcard(require("./constants"));

var _isGroupChallenge = _interopRequireDefault(require("./isGroupChallenge"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var getChallengeState = function getChallengeState(challenge) {
  var now = (0, _moment["default"])();
  var isGroup = (0, _isGroupChallenge["default"])(challenge);

  if (!challenge || !challenge.timeframe) {
    return CONSTANTS.State.UNKNOWN;
  }

  if ((0, _moment["default"])(challenge.timeframe.start) > now) {
    if (isGroup) {
      var _challenge$groupChall;

      return ((_challenge$groupChall = challenge.groupChallenge) === null || _challenge$groupChall === void 0 ? void 0 : _challenge$groupChall.isCurrentUserRegistered) ? CONSTANTS.State.NOT_STARTED_REGISTERED : CONSTANTS.State.NOT_STARTED_NOT_REGISTERED;
    } else {
      if (!challenge.userChallenge) {
        return CONSTANTS.State.NOT_STARTED_NOT_REGISTERED;
      }

      return CONSTANTS.State.NOT_STARTED_REGISTERED;
    }
  }

  if ((0, _moment["default"])(challenge.timeframe.start) < now && (0, _moment["default"])(challenge.timeframe.end) > now) {
    if (isGroup) {
      var _challenge$groupChall2, _challenge$groupChall3, _challenge$groupChall4, _challenge$groupChall5;

      if (!((_challenge$groupChall2 = challenge.groupChallenge) === null || _challenge$groupChall2 === void 0 ? void 0 : _challenge$groupChall2.isCurrentUserRegistered)) {
        return CONSTANTS.State.STARTED_NOT_REGISTERED;
      }

      if (((_challenge$groupChall3 = challenge.groupChallenge) === null || _challenge$groupChall3 === void 0 ? void 0 : _challenge$groupChall3.status) === CONSTANTS.State.ON_GOING || ((_challenge$groupChall4 = challenge.groupChallenge) === null || _challenge$groupChall4 === void 0 ? void 0 : _challenge$groupChall4.status) === CONSTANTS.State.WAITING) {
        return CONSTANTS.State.STARTED_REGISTERED;
      }

      if (((_challenge$groupChall5 = challenge.groupChallenge) === null || _challenge$groupChall5 === void 0 ? void 0 : _challenge$groupChall5.status) === CONSTANTS.State.SUCCESS) {
        return CONSTANTS.State.STARTED_FINISHER;
      }
    } else {
      var _challenge$userChalle, _challenge$userChalle2;

      if (!challenge.userChallenge) {
        return CONSTANTS.State.STARTED_NOT_REGISTERED;
      }

      if (((_challenge$userChalle = challenge.userChallenge) === null || _challenge$userChalle === void 0 ? void 0 : _challenge$userChalle.status) === CONSTANTS.State.ON_GOING) {
        return CONSTANTS.State.STARTED_REGISTERED;
      }

      if (((_challenge$userChalle2 = challenge.userChallenge) === null || _challenge$userChalle2 === void 0 ? void 0 : _challenge$userChalle2.status) === CONSTANTS.State.SUCCESS) {
        return CONSTANTS.State.STARTED_FINISHER;
      }
    }
  }

  if ((0, _moment["default"])(challenge.timeframe.end) < now) {
    if (isGroup) {
      var _challenge$groupChall6, _challenge$groupChall7, _challenge$groupChall8;

      if (!((_challenge$groupChall6 = challenge.groupChallenge) === null || _challenge$groupChall6 === void 0 ? void 0 : _challenge$groupChall6.isCurrentUserRegistered)) {
        return CONSTANTS.State.FINISHED_NOT_REGISTERED;
      }

      if (((_challenge$groupChall7 = challenge.groupChallenge) === null || _challenge$groupChall7 === void 0 ? void 0 : _challenge$groupChall7.status) === CONSTANTS.State.FINISH) {
        return CONSTANTS.State.FINISHED_NOT_FINISHER;
      }

      if (((_challenge$groupChall8 = challenge.groupChallenge) === null || _challenge$groupChall8 === void 0 ? void 0 : _challenge$groupChall8.status) === CONSTANTS.State.SUCCESS) {
        return CONSTANTS.State.FINISHED_FINISHER;
      }
    } else {
      var _challenge$userChalle3, _challenge$userChalle4;

      if (!challenge.userChallenge) {
        return CONSTANTS.State.FINISHED_NOT_REGISTERED;
      }

      if (((_challenge$userChalle3 = challenge.userChallenge) === null || _challenge$userChalle3 === void 0 ? void 0 : _challenge$userChalle3.status) === CONSTANTS.State.FINISH) {
        return CONSTANTS.State.FINISHED_NOT_FINISHER;
      }

      if (((_challenge$userChalle4 = challenge.userChallenge) === null || _challenge$userChalle4 === void 0 ? void 0 : _challenge$userChalle4.status) === CONSTANTS.State.SUCCESS) {
        return CONSTANTS.State.FINISHED_FINISHER;
      }
    }
  }

  return CONSTANTS.State.UNKNOWN;
};

var _default = getChallengeState;
exports["default"] = _default;
//# sourceMappingURL=getChallengeState.js.map